// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4dde5ab","732":"b83fbebb","977":"79be9683"}[chunkId] + ".chunk.js";
};